import { render, staticRenderFns } from "./AddToMonitoringZone.vue?vue&type=template&id=01a5c220&"
import script from "./AddToMonitoringZone.vue?vue&type=script&lang=js&"
export * from "./AddToMonitoringZone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports